/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Engagement_PriceInputs */

const en_marketing_engagement_price = /** @type {(inputs: Marketing_Engagement_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Included`)
};

const es_marketing_engagement_price = /** @type {(inputs: Marketing_Engagement_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incluido`)
};

const fr_marketing_engagement_price = /** @type {(inputs: Marketing_Engagement_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inclus`)
};

/**
* | output |
* | --- |
* | "Included" |
*
* @param {Marketing_Engagement_PriceInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_engagement_price = /** @type {((inputs?: Marketing_Engagement_PriceInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Engagement_PriceInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_engagement_price(inputs)
	if (locale === "es") return es_marketing_engagement_price(inputs)
	return fr_marketing_engagement_price(inputs)
});